import { render, staticRenderFns } from "./NewDriver.vue?vue&type=template&id=c313a1ce&scoped=true"
import script from "./NewDriver.vue?vue&type=script&lang=js"
export * from "./NewDriver.vue?vue&type=script&lang=js"
import style0 from "./NewDriver.vue?vue&type=style&index=0&id=c313a1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c313a1ce",
  null
  
)

export default component.exports